const userState = (state = {
    state: {
        myTasks: {}
    },
    fetchInfo: {}
}, action) => {
    if (action.error) {
        return state;
    }

    switch (action.type) {
        case 'TEAM_CHANGE':
        case 'RESET_STORE':
            return {
                state: {
                    myTasks: {}
                },
                fetchInfo: {}
            };

        case 'USER_STATE_FETCH_REQUESTED':
            return Object.assign({}, state, {
                fetchInfo: {
                    ...state.fetchInfo,
                    loading: true
                }
            });

        case 'USER_STATE_FETCH_SUCCEEDED':
            if (!action.payload.state) {
                return state;
            }

            return Object.assign({}, state, {
                state: action.payload.state,
                fetchInfo: {
                    ...state.fetchInfo,
                    loading: false,
                    fetched: true
                }
            });

        case 'USER_STATE_CHATS_UPDATE_REQUESTED':
            return Object.assign({}, state, {
                state: {
                    ...state.state,
                    team_chats: {
                        ...state.state.team_chats,
                        ...action.payload
                    }
                }
            });

        case 'USER_STATE_SUBTEAMS_UPDATE_REQUESTED':
            return Object.assign({}, state, {
                state: {
                    ...state.state,
                    subteams: {
                        ...state.state.subteams,
                        ...action.payload
                    }
                }
            });

        case 'USER_STATE_ALL_TASKS_UPDATE_REQUESTED':
            return Object.assign({}, state, {
                state: {
                    ...state.state,
                    allTasks: {
                        tasks: {
                            ...(state.state.allTasks.tasks || {}),
                            ...(action.payload.tasks || {})
                        }
                    }
                }
            });

        case 'USER_STATE_MY_TASKS_UPDATE_REQUESTED':
            return Object.assign({}, state, {
                state: {
                    ...state.state,
                    myTasks: {
                        calendarCollapsed: action.payload.calendarCollapsed ?? state.state.myTasks?.calendarCollapsed,
                        tasks: {
                            ...(state.state?.myTasks.tasks || {}),
                            ...(action.payload.tasks || {})
                        }
                    }
                }
            });

        case 'USER_STATE_PROJECT_UPDATE_REQUESTED':
            return Object.assign({}, state, {
                state: {
                    ...state.state,
                    projects: {
                        ...state.state.projects,
                        [action.payload.projectId] : {
                            ...((state.state.projects || {})[action.payload.projectId] || {}),
                            ...action.payload.projectState
                        }
                    }
                }
            });

        case 'USER_STATE_PROJECT_TASKS_UPDATE_REQUESTED':
            return Object.assign({}, state, {
                state: {
                    ...state.state,
                    projects: {
                        ...state.state.projects,
                        [action.payload.projectId]: {
                            ...((state.state.projects || {})[action.payload.projectId] || {}),
                            tasks: {
                                ...(((state.state.projects || {})[action.payload.projectId] || {}).tasks || {}),
                                ...action.payload.projectTasksState
                            }
                        }
                    }
                }
            });

        case 'USER_STATE_WORKLOADS_UPDATE_REQUESTED':
            return Object.assign({}, state, {
                state: {
                    ...state.state,
                    workloads: {
                        ...state.state.workloads,
                        [action.payload.type]: {
                            start: action.payload.start,
                            end: action.payload.end
                        }
                    }
                }
            });

        default:
            return state;
    }
}

export default userState;
